import React from 'react';
import { SystemIcon } from '../../../../Icon';
import * as tokens from '@utmost.co/utmost-design-tokens';

export const CheckIcon = () => <SystemIcon name="check" color={tokens.colorPrimary} />;
